export const socialLinks = {
    'facebook': 'http://www.facebook.com/sharer.php?u=%u%',
    'twitter' : 'https://twitter.com/share?url=%u%&text=%t%',
    'reddit'  : 'https://www.reddit.com/submit?url=%u%&resubmit=true&title=%t%',
    'google'  : 'https://plus.google.com/share?url=%u%'
};
